import { cn } from '@/lib/utils';

type Props = {
  tabs: Array<{ id: string; label: string; count?: number }>;
  value: string;
  onChange: (id: string) => void;
};

export function DebugTabs({ tabs, value, onChange }: Props) {
  return (
    <div role="tablist" className="flex gap-0 border-b-2 border-border mb-6 overflow-x-auto">
      {tabs.map((t) => {
        const active = value === t.id;
        return (
          <button
            key={t.id}
            role="tab"
            aria-selected={active}
            onClick={() => onChange(t.id)}
            className={cn(
              'font-(family-name:--font-ui) text-[0.8rem] font-medium uppercase tracking-[0.15em]',
              'px-5 py-3 border-b-[3px] transition-colors whitespace-nowrap min-h-11',
              active
                ? 'border-accent text-text'
                : 'border-transparent text-muted hover:text-text'
            )}
          >
            {t.label}
            {typeof t.count === 'number' && (
              <span className={active ? 'ml-2 text-muted' : 'ml-2 text-subtle'}>
                ({t.count})
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
